import React from 'react';

import styles from '../../styles.module.css';

const SuggestChips = ({ chips, onSelect }) => (
	<div className={styles.suggestRow}>
		{chips.map((chip) => (
			<button
				key={chip}
				type="button"
				className={styles.suggestChip}
				onClick={() => onSelect(chip)}
			>
				{chip}
			</button>
		))}
	</div>
);

export default SuggestChips;
